export enum PERMISSIONS {
  SYNCING_NOTIFICATION = "SYNCING_NOTIFICATION",
  //เมณูคำสั่งซื้อ
  ORDER_MANAGEMENT_READ = "ORDER_MANAGEMENT_READ",
  ORDER_MANAGEMENT_EXPORT = "ORDER_MANAGEMENT_EXPORT",
  //เมณูรายการค้างชำระ
  OVERDUE_TRANSACTION_MANAGEMENT_READ = "OVERDUE_TRANSACTION_MANAGEMENT_READ",
  OVERDUE_TRANSACTION_MANAGEMENT_EDIT = "OVERDUE_TRANSACTION_MANAGEMENT_EDIT",
  //เมนูสถานะกรมธรรม์
  INSURANCE_TRANSACTION_MANAGEMENT_READ = "INSURANCE_TRANSACTION_MANAGEMENT_READ",
  INSURANCE_TRANSACTION_MANAGEMENT_EDIT = "INSURANCE_TRANSACTION_MANAGEMENT_EDIT",

  //เมนูการชำระเงิน
  PAYMENT_TRANSACTION_MANAGEMENT_READ = "PAYMENT_TRANSACTION_MANAGEMENT_READ",

  //เมนูจัดการการแจ้งเตือน
  NOTIFICATION_MANAGEMENT_READ = "NOTIFICATION_MANAGEMENT_READ",
  NOTIFICATION_MANAGEMENT_EDIT = "NOTIFICATION_MANAGEMENT_EDIT",

  //เมนู Log ค้นหาประกัน
  LEAD_MANAGEMENT_READ = "LEAD_MANAGEMENT_READ",
  LEAD_MANAGEMENT_EDIT = "LEAD_MANAGEMENT_EDIT",
  LEAD_MANAGEMENT_EXPORT = "LEAD_MANAGEMENT_EXPORT",

  //เมนูออกรายงาน
  // REPORT_MANAGEMENT_READ = "REPORT_MANAGEMENT_READ",
  // REPORT_MANAGEMENT_EDIT = "REPORT_MANAGEMENT_EDIT",

  //เมณูคำขอเปลี่ยนชื่อ
  NAME_CHANGE_TRANSACTION_MANAGEMENT_READ = "NAME_CHANGE_TRANSACTION_MANAGEMENT_READ",
  NAME_CHANGE_TRANSACTION_MANAGEMENT_EDIT = "NAME_CHANGE_TRANSACTION_MANAGEMENT_EDIT",

  //เมนูเพิ่ม/ลด ข้อมูลแบบประกัน
  MASTER_INSURANCE_PLAN_MANAGEMENT_READ = "MASTER_INSURANCE_PLAN_MANAGEMENT_READ",
  MASTER_INSURANCE_PLAN_MANAGEMENT_EDIT = "MASTER_INSURANCE_PLAN_MANAGEMENT_EDIT",

  //เมนูจัด Package และจัด Weight
  INSURANCE_MANAGEMENT_READ = "INSURANCE_MANAGEMENT_READ",
  INSURANCE_MANAGEMENT_EDIT = "INSURANCE_MANAGEMENT_EDIT",

  //เมนูเปิด/ปิด ประกันและ Package
  ENROLLMENT_MANAGEMENT_READ = "ENROLLMENT_MANAGEMENT_READ",
  ENROLLMENT_MANAGEMENT_EDIT = "ENROLLMENT_MANAGEMENT_EDIT",

  // เมนูการแสดงผลหน้า App
  FRONT_STORE_MANAGEMENT_READ = "FRONT_STORE_MANAGEMENT_READ",
  FRONT_STORE_MANAGEMENT_EDIT = "FRONT_STORE_MANAGEMENT_EDIT",

  //เมณูเพิ่ม/ลด Broker
  BROKER_MANAGEMENT_READ = "BROKER_MANAGEMENT_READ",
  BROKER_MANAGEMENT_EDIT = "BROKER_MANAGEMENT_EDIT",

  //เมนูเพิ่ม/ลด บริษัทประกัน
  INSURANCE_COMPANY_MANAGEMENT_READ = "INSURANCE_COMPANY_MANAGEMENT_READ",
  INSURANCE_COMPANY_MANAGEMENT_EDIT = "INSURANCE_COMPANY_MANAGEMENT_EDIT",

  //เมนูเพิ่ม/ลด อาชีพ
  OCCUPATION_MANAGEMENT_READ = "OCCUPATION_MANAGEMENT_READ",
  OCCUPATION_MANAGEMENT_EDIT = "OCCUPATION_MANAGEMENT_EDIT",

  //เมนูข้อมูลลูกค้า
  USER_MANAGEMENT_READ = "USER_MANAGEMENT_READ",

  //เมนูกำหนดสิทธิ
  PERMISSION_MANAGEMENT_READ = "PERMISSION_MANAGEMENT_READ",
  PERMISSION_MANAGEMENT_EDIT = "PERMISSION_MANAGEMENT_EDIT",

  //เมนูเพิ่ม/ลด Admin
  ADMIN_MANAGEMENT_READ = "ADMIN_MANAGEMENT_READ",
  ADMIN_MANAGEMENT_EDIT = "ADMIN_MANAGEMENT_EDIT",

  //เมนูเพิ่ม/ลด Workspace
  WORKSPACE_MANAGEMENT_READ = "WORKSPACE_MANAGEMENT_READ",
  WORKSPACE_MANAGEMENT_EDIT = "WORKSPACE_MANAGEMENT_EDIT",
  //เมนูการตั้งค่า
  // SETTING_MANAGEMENT_READ = "SETTING_MANAGEMENT_READ",
  // SETTING_MANAGEMENT_EDIT = "SETTING_MANAGEMENT_EDIT",
  T = "T",
}
